import { render, staticRenderFns } from "./LsvaTrailersTable.vue?vue&type=template&id=7eaa836d&scoped=true&"
import script from "./LsvaTrailersTable.vue?vue&type=script&lang=js&"
export * from "./LsvaTrailersTable.vue?vue&type=script&lang=js&"
import style0 from "./LsvaTrailersTable.vue?vue&type=style&index=0&id=7eaa836d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaa836d",
  null
  
)

/* custom blocks */
import block0 from "./LsvaTrailersTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports